import dayjs from 'dayjs';
import SlideToggle from '~/components/common/SlideToggle.vue';
export default {
  name: 'FormPlanInfo',
  components: {
    SlideToggle
  },
  props: {
    selectedPlan: {
      type: Object,
      required: true
    },
    disableChangePlan: {
      type: Boolean,
      default: false
    },
    billingCycle: {
      type: Number,
      required: true
    },
    autopay: {
      type: Boolean,
      required: true
    },
    allowAutopayChange: {
      type: Boolean,
      default: false
    },
    accountLastFour: {
      type: String,
      required: true
    },
    processDate: {
      type: dayjs,
      required: true
    }
  },
  computed: {
    inputAutopay: {
      get() {
        return this.autopay;
      },
      set(newVal) {
        this.$emit('update:autopay', newVal);
      }
    }
  }
};